import {Module} from '@mamdev/cad.static-next-lib';
import Viewport from '../../ts/services/viewport';
import Tracking2 from '../../ts/services/tracking2';

export default class Intro extends Module {
  private wrapper: HTMLElement;
  private collapsible: HTMLElement;
  private arrow: Element | null;

  public maxheight: number;
  public hasImage: boolean;
  private eventAttached: boolean;

  // Init. from DOM.
  static attachTo(root: HTMLElement): Intro {
    return new Intro(root);
  }

  constructor(root: HTMLElement) {
    super(root);
    this.name_ = 'intro';
  }

  // Start the module.
  start() {
    this.wrapper = (this.root_.getElementsByClassName('collapsible-wrapper')[0] as HTMLElement);
    const collapsibleElement = this.root_.querySelector<HTMLElement>('.collapsible');

    // prevent sement or pages without this wrapper to throw an error (CADNPCA-3788)
    if (!this.wrapper || !collapsibleElement || this.root_.classList.contains('sement')) {
      return;
    }

    this.collapsible = collapsibleElement;
    this.arrow = this.root_.querySelector('.arrow-down-svg');
    this.hasImage = this.root_.className.includes('with-img');
    this.maxheight = 0;
    this.eventAttached = false;

    // Continue only if arrow exists
    if (this.arrow) {
      this.arrowHandler();
      // Listen to viewport change
      this.subscribe('window:resize', () => {
        this.arrowHandler();
      });
      this.subscribe('layoutChanged', () => {
        this.arrowHandler();
      });
    }

    const trackedElement = this.root_.querySelectorAll('[data-component-path]');
    Tracking2.bindTrackingClickHandler(trackedElement);
  }

  // Show and attach click/touch event to arrow or hide arrow depending on the height of the text-block
  arrowHandler() {
    this.setMaxHeight();

    // Show arrow and attach event
    if (this.collapsible.offsetHeight > this.maxheight) {
      this.arrow?.classList.remove('hidden');
      this.closeIntroContainer();
      // Attach event only once
      if (!this.eventAttached) {
        this.eventAttached = true;
        this.attachArrowClickEvent();
      }
    } else {
      this.arrow?.classList.add('hidden');
      this.openIntroContainer();
    }
  }

  setMaxHeight() {
    if (this.root_.className.includes('is-taglist')) {
      if (this.hasImage && Viewport.largerThan('tablet')) {
        this.maxheight = 155;
      } else {
        this.maxheight = 78;
      }
    } else {
      this.maxheight = 1000;
    }
  }

  attachArrowClickEvent() {
    this.arrow?.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      this.toggleCollapsed();
    });
  }

  // hide/show the intro paragraph
  toggleCollapsed() {
    if (this.root_.className.includes('closed')) {
      this.openIntroContainer();
    } else {
      // remove max-height property to allow for CSS transitions
      this.wrapper.style.maxHeight = 'none';
      this.closeIntroContainer();
    }
  }

  openIntroContainer() {
    this.root_.classList.remove('closed');
    if (this.hasImage && this.wrapper.offsetHeight >= this.collapsible.offsetHeight) {
      this.wrapper.style.height = '';
    } else {
      this.wrapper.style.height = `${this.collapsible.offsetHeight}px`;
    }
  }

  closeIntroContainer() {
    this.root_.classList.add('closed');
    this.wrapper.style.height = `${this.maxheight}px`;
  }
}
